<template>
  <div style="background: #1e77b7;">
    <v-form ref="form" v-model="valid" lazy-validation style="max-width: 70rem;
    width: 100%;
    margin: auto;">
      <v-card-text>
        <v-container>
          <v-card elevation="7" style="">
            <v-card-title>
              <span class="text-h5" style="color: rgb(0 108 187); font-weight: 600;">Solicitud de cambio de
                IPRESS</span>
            </v-card-title>
          </v-card>
          <v-card elevation="7" style="padding:3rem 2rem; margin-top: 1rem;">
            <h4 style="color: rgb(0 108 187);">Datos del Paciente</h4>
            <v-divider style="margin-bottom: 2rem;"></v-divider>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.num_docPaciente" label="Ingrese DNI del paciente*"
                  :maxlength="maxdat" @keyup.enter="loadPaciente" required
                  :rules="[(v) => !!v || 'Este campo es obligatorio']"></v-text-field>
                <v-btn @click="loadPaciente">Buscar</v-btn>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.nombre" label="Nombre y Apellidos" :maxlength="maxdat"
                  disabled></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete v-model="dataSolicitud.ipress" :items="itemsIpress" dense item-text="descripCas"
                  item-value="url" label="Clínica Actual" :maxlength="90" disabled></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete v-model="dataSolicitud.distrito" :items="itemsDistrito" dense item-text="distrito"
                  item-value="url" label="Distrito Actual" :maxlength="90" disabled></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.telefono" label="Teléfono" :maxlength="maxdat"
                  :disabled="statusTelefono"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.telefonoAlterno" label="Añadir otro teléfono"></v-text-field>
              </v-col>
            </v-row>
          </v-card>
          <v-card elevation="7" style="padding:3rem 2rem;margin-top: 1rem;">
            <h4 style="    color: rgb(0 108 187);">Motivo de Cambio</h4>
            <v-divider style="margin-bottom: 2rem;"></v-divider>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-select v-model="dataSolicitud.motivo"
                  :items="['Discapacidad (Limitación física no le permite trasladarse)', 'Cambio de domicilio (El domicilio debe figurar en el DNI, en caso contratrio no procederá la reasignación de centro de hemodialisis)', 'Problemas de distancia (Lejano a su domicilio)', 'Problemas familiares (No cuenta con familiar que pueda acompañarlo)', 'Problemas económicos (No tiene los medios para movilizarse)', 'Problemas de adaptación (Retorno al centro anterior)', 'Problemas laborales (Secuencia o turno no se adecua con su trabajo)', 'Inconformidad con el servicio', 'Otro']"
                  label="Indique el motivo por el cual desea cambiar de IPRESS*" @change="updateMotivo"
                  :rules="[(v) => !!v || 'Este campo es obligatorio']"></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-if="stateOtro" v-model="dataSolicitud.otro" label="Otro Motivo"
                  :maxlength="maxdat"></v-text-field>
              </v-col>
            </v-row>
            <br>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete v-model="dataSolicitud.distrito_nuevo" :items="itemsDistrito" dense item-text="distrito"
                  item-value="url" label="Seleccione el distrito donde desea ser atentido - primera opción*"
                  :maxlength="90" @change="loadIpressNuevo"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete v-model="dataSolicitud.ipress_nuevo" :items="itemsIpressNuevo" dense
                  item-text="descripCas" item-value="url" label="Seleccione el nombre de la clínica*"
                  :maxlength="90"></v-autocomplete>
              </v-col>
            </v-row>
            <br>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete v-model="dataSolicitud.distrito_nuevo2" :items="itemsDistrito" dense
                  item-text="distrito" item-value="url"
                  label="Seleccione el distrito donde desea ser atentido - segunda opción*" :maxlength="90"
                  @change="loadIpressNuevo2"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete v-model="dataSolicitud.ipress_nuevo2" :items="itemsIpressNuevo2" dense
                  item-text="descripCas" item-value="url" label="Seleccione el nombre de la clínica*"
                  :maxlength="90"></v-autocomplete>
              </v-col>
            </v-row>
          </v-card>
          <v-card elevation="7" style="padding:3rem 2rem;margin-top: 1rem;">
            <h4 style="  color: rgb(0 108 187);">¿La solicitud es registrada por el paciente?*</h4>
            <v-row>
              <v-col cols="12" sm="6" md="6" class="d-flex">
                <v-checkbox v-model="titularSi" :label="`No`" style="margin-right: 1rem;"
                  @click="updateEstado('titularSi')"></v-checkbox>
                <v-checkbox v-model="titularNo" :label="`Sí`" @click="updateEstado('titularNo')"></v-checkbox>
              </v-col>
            </v-row>
            <v-row v-if="titularSi">
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.num_doc" label="Registre el DNI del familiar*"
                  :rules="[(v) => !!v || 'Este campo es obligatorio']"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.nombre_parentesco" label="Nombres y Apellidos *"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="titularSi">
              <v-col cols="12" sm="6" md="6">
                <v-select v-model="dataSolicitud.parentesco"
                  :items="['Padre/Madre', 'Esposa/o', 'Hija/o', 'Abuela/o', 'Hermana/o', 'Otro']" label="Parentesco *"
                  :rules="[(v) => !!v || 'Este campo es obligatorio']" @change="updateParentesco"></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-if="statusOtroParentesco" v-model="dataSolicitud.parentesco_otro"
                  label="Otro parentesco *"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="titularSi">
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.correo" label="Correo *"
                  :rules="[(v) => !!v || 'Este campo es obligatorio']"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field v-model="dataSolicitud.telefono2" label="Celular *" :maxlength="maxdat"
                  :rules="[(v) => !!v || 'Este campo es obligatorio']"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-checkbox style="font-style: italic;" v-model="dataSolicitud.tratamiento_datos"
                  :label="`Brinda consentimiento del tratamiento de sus datos para el envío de mensajes alusivos al centro`"></v-checkbox>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="validarCampos" v-if="!statusFormEdit"> Grabar </v-btn>
              <!-- <v-btn text @click="generatePDFPrueba" v-if="!statusFormEdit"> Grabar </v-btn> -->
              <v-btn text @click="validarCampos" v-if="statusFormEdit"> Editar </v-btn>
              <!-- <v-btn text @click="generatePDF"> Grabar </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-container>
      </v-card-text>
    </v-form>
    <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
      <v-card color="#1973a5" dark>
        <v-card-text>
          Cargando Datos
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<style scoped>
.swal2-shown.swal2-height-auto {
  padding: 0 !important;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import "jspdf-autotable";
import Swal from "sweetalert2";
import jsPDF from "jspdf";

export default {
  props: ['itemsSend'],
  data: () => ({
    statusFormEdit: false,
    dialogLoader: false,
    //Perfil Usuario
    perfil: "",
    nombre: "",
    url: "",
    usuario: "",
    //Distritos
    itemsDistrito: [],
    //IPRESS
    itemsIpress: [],
    //PDFExport
    dataPdfExport: [],
    //IPRESS Nuevo
    itemsIpressNuevo: [],
    //IpressNuevo2
    itemsIpressNuevo2: [],
    //Paciente
    dataPaciente: [],
    //Datos Formulario
    dataSolicitud: {
      id_pacienteLocalizacion: null,
      num_docPaciente: null,
      nombre: null,
      ipress: null,
      distrito: null,
      telefono: null,
      telefonoAlterno: null,
      motivo: null,
      otro: null,
      distrito_nuevo: null,
      ipress_nuevo: null,
      distrito_nuevo2: null,
      ipress_nuevo2: null,
      num_doc: null,
      parentesco: null,
      telefono2: null,
      es_titular: null,
      fecha: new Date().toISOString().substr(0, 10),
      id_cas_1: null,
      id_cas_2: null,
      paciente_id: null,
      correo: null,
      parentesco_otro: null,
      nombre_parentesco: null,
      tratamiento_datos: false,
      estado: null,
      url: null
    },
    //Formulario Parámetros
    titularSi: true,
    titularNo: false,
    valid: true,
    maxdat: 100,
    stateOtro: false,
    statusOtroParentesco: false,
    rules: {
      required: (value) => !!value || "Campo Obligatorio.",
      counter: (value) => value <= 20 || "Max 20 characters",
    },
    statusTelefono: true,
    itemsDistrito1: [],
    itemsDistrito2: [],
    itemsIpress1: [],
    itemsIpress2: []
  }),

  computed: {},
  watch: {
    titularSi(newValue) {
      // Si titularSi está marcado como "Sí", deselecciona titularNo
      if (newValue) {
        this.titularNo = false;
      }
    },
    titularNo(newValue) {
      // Si titularNo está marcado como "No", deselecciona titularSi
      if (newValue) {
        this.titularSi = false;
      }
    }
  },
  methods: {
    editCreate() {
      this.dataSolicitud.num_docPaciente = this.itemsSend.datosPaciente.num_doc;
      this.dataSolicitud.nombre = this.itemsSend.datosPaciente.nombre_completo;
      this.dataSolicitud.ipress = this.itemsSend.datosPaciente.cas;
      this.dataSolicitud.distrito = this.itemsSend.datosPaciente.datosUbigeo.url;
      this.dataSolicitud.telefono = this.itemsSend.datosPaciente.telefono;
      this.dataSolicitud.telefonoAlterno = this.itemsSend.datosPaciente.telefonoAlterno;
      this.dataSolicitud.motivo = this.itemsSend.motivo;
      this.dataSolicitud.id_cas_1 = this.itemsSend.id_cas_1;
      this.dataSolicitud.id_cas_2 = this.itemsSend.id_cas_2;
      this.dataSolicitud.distrito_nuevo = this.itemsSend.id_cas_1;
      this.dataSolicitud.ipress_nuevo = this.itemsSend.id_cas_1;
      this.dataSolicitud.distrito_nuevo2 = this.itemsSend.id_cas_2;
      this.dataSolicitud.ipress_nuevo2 = this.itemsSend.id_cas_2;
      this.dataSolicitud.nombre_parentesco = this.itemsSend.nombre_parentesco;
      this.dataSolicitud.parentesco = this.itemsSend.parentesco;
      this.dataSolicitud.correo = this.itemsSend.correo;
      this.dataSolicitud.tratamiento_datos = this.itemsSend.tratamiento_datos;
      this.dataSolicitud.url = this.itemsSend.url;
      this.dataSolicitud.paciente_id = this.itemsSend.paciente_id;
      this.dataSolicitud.num_doc = this.itemsSend.num_doc;
      this.titularNo = this.itemsSend.es_titular ? false : true;
      this.titularSi = this.itemsSend.es_titular ? true : false;
      this.dataSolicitud.telefono2 = this.itemsSend.telefono;
      this.dataSolicitud.fecha = this.itemsSend.fecha;
      this.loadIpressNuevoEdit();
      this.loadIpressNuevo2Edit();
    },
    updateEstado(selectedCheckbox) {
      if (selectedCheckbox === 'titularSi' && !this.titularSi) {
        this.titularNo = true;
      } else if (selectedCheckbox === 'titularNo' && !this.titularNo) {
        this.titularSi = true;
      }
    },
    convertirNumLetra(fecha) {
      var meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
      var mesNumero = parseInt(fecha.split("-")[1], 10);
      var mesLetra = meses[mesNumero - 1];
      return mesLetra;
    },
    filtroIpressActual(ipress) {
      const labelIpress = this.itemsIpress.filter(
        (e) => e.url == ipress
      )
      return labelIpress[0].descripCas;
    },
    filtroIpress(ipress) {
      var valor;
      if (ipress) {
        const labelIpress = this.itemsIpressNuevo.filter(
          (e) => e.url == ipress
        )
        valor = labelIpress[0].descripCas;
      } else {
        valor = "";
      }
      return valor;
    },
    filtroIpress2(ipress) {
      var valor;
      if (ipress) {
        const labelIpress2 = this.itemsIpressNuevo2.filter(
          (e) => e.url == ipress
        )
        valor = labelIpress2[0].descripCas;
      } else {
        valor = "";
      }
      return valor;
    },
    getImageBase64(imagePath) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous'; // Esto es necesario si la imagen está en otro dominio
        img.src = imagePath;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        };
        img.onerror = (error) => {
          reject(error);
        };
      });
    },
    async generatePDF() {
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "cm",
        format: "a4",
      });
      const textos = [
        { bold: true, size: 12, label: "CONSTANCIA", align: "center" },
        /* { bold: true, size: 10, label: "", align: "center" }, */
        { bold: true, size: 12, label: "SOLICITUD DE CAMBIO DE IPRESS", align: "center" },
        /* { bold: true, size: 12, label: "", align: "center" }, */
        { bold: false, size: 12, label: "Centro Nacional de Salud Renal", align: "center" },
        { bold: false, size: 12, label: `Fecha de Solicitud: ${this.dataSolicitud.fecha}`, align: "center" },
        { bold: false, size: 12, label: `Motivo: ${this.dataSolicitud.motivo === "Otro" ? this.dataSolicitud.otro : this.dataSolicitud.motivo}`, align: "center" },

        { bold: false, size: 12, label: "", align: "center" },
        { bold: false, size: 12, label: "Por medio del presente dejamos constancia que el paciente detallado líneas abajo, ha", align: "justificado" },
        { bold: false, size: 12, label: "registrado su solicitud para cambiar el lugar donde realiza el proceso de diálisis:", align: "justificado" },
        { bold: false, size: 12, label: "", align: "justificado" },

        { bold: true, size: 12, label: `Paciente: ${this.dataSolicitud.nombre}`, align: "center" },
        { bold: false, size: 12, label: `DNI: ${this.dataSolicitud.num_docPaciente}`, align: "center" },
        { bold: false, size: 12, label: `IPRESS Actual:  ${this.filtroIpressActual(this.dataSolicitud.ipress)}`, align: "center" },
        { bold: false, size: 12, label: `IPRESS Opción 1: ${this.filtroIpress(this.dataSolicitud.ipress_nuevo)}`, align: "center" },
        { bold: false, size: 12, label: `IPRESS Opción 2: ${this.filtroIpress2(this.dataSolicitud.ipress_nuevo2)}`, align: "center" },
        { bold: false, size: 12, label: "", aling: "justificado" },
        { bold: false, size: 12, label: "", align: "justificado" },

        { bold: false, size: 12, label: "Extendemos la presente constancia para los fines que  estime  pertinentes. La presente", align: "justificado" },
        { bold: false, size: 12, label: "constancia no asegura el cambio inmediato del lugar de atención, ya que esto dependerá", align: "justificado" },
        { bold: false, size: 12, label: "de la disponibilidad de cupos, cuando el cambio se dé el área de admisión   se pondrá en", align: "justificado" },
        { bold: false, size: 12, label: "contacto con usted al número indicado.", align: "justificado" },
        { bold: false, size: 12, label: "", align: "justificado" },
        { bold: false, size: 12, label: "", align: "justificado" },
        { bold: false, size: 12, label: `Lima, ${this.dataSolicitud.fecha.split("-")[2]} de ${this.convertirNumLetra(this.dataSolicitud.fecha)} de ${this.dataSolicitud.fecha.split("-")[0]}`, align: "justificado" },
      ];
      const pageSize = doc.internal.pageSize;
      for (let i = 0; i < textos.length; i++) {
        const element = textos[i];
        let x;
        if (element.bold === true) {
          doc.setFont('helvetica', 'bold');
        } else {
          doc.setFont('helvetica', 'normal');
        }
        if (element.align === "center") {
          const textWidth = doc.getTextWidth(element.label);
          x = (pageSize.width - textWidth) / 2;
        } else {
          x = 2;
        }
        doc.setFontSize(element.size);
        const y = 5 + i - 0.5;
        doc.text(element.label, x, y);
      }

      const imagePath = 'logo_cnsr.png';
      try {
        const imgData = await this.getImageBase64(imagePath);
        /* doc.addImage(imgData, 'PNG', 1, 1, 4, 4); */
        doc.addImage(imgData, 'PNG', 1, 1, 6, 2);
      } catch (error) {
        console.error("Error loading image:", error);
      }
      const imagePath2 = 'logo_essalud.png';
      try {
        const imgData = await this.getImageBase64(imagePath2);
        /* doc.addImage(imgData, 'PNG', 1, 1, 4, 4); */
        doc.addImage(imgData, 'PNG', 11, 1, 8, 1.8);
      } catch (error) {
        console.error("Error loading image:", error);
      }

      doc.save("constancia_solicitud_ipress.pdf");
    },
    updateParentesco() {
      if (this.dataSolicitud.parentesco == "Otro") {
        this.statusOtroParentesco = true;
      } else {
        this.statusOtroParentesco = false;
      }
    },
    updateMotivo() {
      if (this.dataSolicitud.motivo == "Otro") {
        this.stateOtro = true;
      } else {
        this.stateOtro = false;
      }
    },
    validarCampos() {
      this.dialogLoader = true;
      this.dataSolicitud.es_titular = this.titularSi;
      if (this.dataSolicitud.num_docPaciente == "" || this.dataSolicitud.motivo == "" || this.dataSolicitud.distrito_nuevo == "" || this.dataSolicitud.ipress_nuevo == "" || this.dataSolicitud.es_titular == null) {
        Swal.fire({
          title: "Error!",
          text: "¡Debe completar todos los campos obligatorios! (*)",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
        this.dialogLoader = false;
      } else if (this.titularSi == true && (this.dataSolicitud.num_doc == null || this.dataSolicitud.parentesco == null || this.dataSolicitud.telefono2 == null || this.dataSolicitud.correo == null || this.dataSolicitud.nombre_parentesco == null)) {
        Swal.fire({
          title: "Error!",
          text: "¡Debe completar todos los campos obligatorios! (*)",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
        this.dialogLoader = false;
      } else {
        if (this.statusFormEdit) {
          this.editGrabar();
        } else {
          this.grabar();
        }
      }
    },
    grabar() {
      this.dialogLoader = true;
      this.dataSolicitud.es_titular = this.titularSi;
      this.dataSolicitud.id_cas_1 = this.dataSolicitud.ipress_nuevo;
      this.dataSolicitud.id_cas_2 = this.dataSolicitud.ipress_nuevo2;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .patch(RUTA_API + "/paciente/" + this.dataSolicitud.id_pacienteLocalizacion + "/",
              {
                num_doc: this.dataSolicitud.num_docPaciente,
                nombre: this.dataSolicitud.nombre,
                telefono: this.dataSolicitud.telefono,
                telefonoAlterno: this.dataSolicitud.telefonoAlterno
              },
              {
                headers: { Authorization: this.auth },
              })
            .then((res) => {
              this.dialogLoader = false;
              this.grabarFormSolicitud();

            })
            .catch((res) => {
              console.log("Error:", res);
              Swal.fire({
                title: "Error!",
                text: "¡No registró correctamente!",
                icon: "error",
                confirmButtonText: "Aceptar",
              });
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    editGrabar() {
      this.dataSolicitud.id_cas_1 = this.dataSolicitud.ipress_nuevo;
      this.dataSolicitud.id_cas_2 = this.dataSolicitud.ipress_nuevo2;
      this.dataSolicitud.telefono = this.dataSolicitud.telefono2;
      this.dialogLoader = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .patch(RUTA_API + "/formularioCambioClinica/" + this.dataSolicitud.url.split("/")[4] + "/", this.dataSolicitud, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.dialogLoader = false;
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se registró correctamente!",
                icon: "success",
                showConfirmButton: true,
                confirmButtonText: "Aceptar"
              }).then((result) => {
                // Este bloque se ejecutará cuando el usuario haga clic en el botón de confirmación
                if (result.isConfirmed) {
                  // Aquí puedes agregar cualquier acción que desees realizar después de que el usuario confirme
                  /* this.generatePDF(); */
                  if (this.usuario) {
                    this.close();
                  } else {
                    window.location.reload();
                  }
                  console.log("Usuario confirmó el éxito.");
                }
              });
            })
            .catch((res) => {
              console.log("Error:", res);
              this.dialogLoader = false;
              Swal.fire({
                title: "Error!",
                text: "¡No registró correctamente!",
                icon: "error",
                confirmButtonText: "Aceptar",
              });
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    grabarFormSolicitud() {
      this.dialogLoader = true;
      this.dataSolicitud.telefono = this.dataSolicitud.telefono2;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/formularioCambioClinica/", this.dataSolicitud, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.dialogLoader = false;
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se registró correctamente!",
                icon: "success",
                showConfirmButton: true,
                confirmButtonText: "Aceptar"
              }).then((result) => {
                // Este bloque se ejecutará cuando el usuario haga clic en el botón de confirmación
                if (result.isConfirmed) {
                  // Aquí puedes agregar cualquier acción que desees realizar después de que el usuario confirme
                  this.generatePDF();
                  if (this.usuario) {
                    this.close();
                  } else {
                    window.location.reload();
                  }
                }
              });
            })
            .catch((res) => {
              this.dialogLoader = false;
              Swal.fire({
                title: "Error!",
                text: "¡No registró correctamente!",
                icon: "error",
                confirmButtonText: "Aceptar",
              });
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    close() {
      this.$emit("update:dialog", false);
    },
    loadIpress() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/cas/", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.itemsIpress = res.data.filter(item => item.estado === true);
              this.itemsIpress1 = res.data.filter(item => item.estado === true);
              this.itemsIpress2 = res.data.filter(item => item.estado === true);
              this.loadDistritos();
            })
            .catch((res) => {
              console.log("Error:", res);
              this.dialog = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    loadIpressNuevo() {
      const distrito = this.itemsDistrito.filter(item => item.url == this.dataSolicitud.distrito_nuevo);
      console.log("distrito filtrados", distrito);
      const clinicaLista = this.itemsIpress1.filter(item => item.distrito == distrito[0].distrito);
      this.itemsIpressNuevo = clinicaLista.filter(item => item.tipoCas !== "1" && item.tipoCas !== "3");
    },
    loadIpressNuevoEdit() {
      /* console.log("Lista los distritos antes del filtro",this.itemsDistrito1);
      console.log("Lista el distito seleccionado",this.itemsSend.datosCas1.distrito); */
      const distrito = this.itemsDistrito1.filter(item => item.distrito == this.itemsSend.datosCas1.distrito);
      /* console.log("Lista los distritos",distrito); */
      this.dataSolicitud.distrito_nuevo = distrito[0].url;
      this.loadIpressNuevo();
    },
    loadIpressNuevo2() {
      const distrito = this.itemsDistrito.filter(item => item.url == this.dataSolicitud.distrito_nuevo2);
      const clinicaLista = this.itemsIpress2.filter(item => item.distrito == distrito[0].distrito);
      this.itemsIpressNuevo2 = clinicaLista.filter(item => item.tipoCas !== "1" && item.tipoCas !== "3");
    },
    loadIpressNuevo2Edit() {
      const distrito = this.itemsDistrito2.filter(item => item.distrito == this.itemsSend.datosCas2.distrito);
      this.dataSolicitud.distrito_nuevo2 = distrito[0].url;
      this.loadIpressNuevo2();
    },
    loadDistritos() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/ubigeo/", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.itemsDistrito = res.data;
              const dataDistrito = res.data.filter(item => item.estado === true);
              /* this.itemsDistrito = dataDistrito.filter(item => item.distrito !== "1"); */
              /* this.itemsDistrito = dataDistrito; */
              console.log("distritos", this.itemsDistrito);
              // Suponiendo que tu array original se llama 'data'
              let distritosUnicos = [];
              let distritosYaVistos = {};

              for (let i = 0; i < this.itemsDistrito.length; i++) {
                let distrito = this.itemsDistrito[i].distrito;
                if (!distritosYaVistos[distrito]) {
                  distritosUnicos.push(this.itemsDistrito[i]);
                  distritosYaVistos[distrito] = true;
                }
              }
              this.itemsDistrito = distritosUnicos;
              this.itemsDistrito1 = distritosUnicos;
              this.itemsDistrito2 = distritosUnicos;
              console.log("se lista los distritos en su totatl", this.itemsDistrito);
              if (this.usuario && this.itemsSend) {
                this.editCreate();
                this.statusFormEdit = true;
              }
            })
            .catch((res) => {
              this.dialog = false;
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    loadPaciente() {
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .get(RUTA_API + "/asigCuposPac/?search=" + this.dataSolicitud.num_docPaciente + ",true", {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.dataPaciente = res.data;
              if (this.dataPaciente[0]) {
                this.dataSolicitud.id_pacienteLocalizacion = this.dataPaciente[0].datosPaciente.url.split("/")[4];
                this.dataSolicitud.paciente_id = this.dataPaciente[0].datosPaciente.url;
                this.dataSolicitud.nombre = this.dataPaciente[0].datosPaciente.nombre_completo;
                this.dataSolicitud.ipress = this.dataPaciente[0].datosPuesto.datosCas.url;
                this.dataSolicitud.distrito = this.dataPaciente[0].datosPaciente.datosUbigeo.url;
                if (!this.dataPaciente[0].telefono && this.dataPaciente[0].datosPaciente.telefonoAlterno) {
                  this.dataSolicitud.telefono = this.dataPaciente[0].datosPaciente.telefonoAlterno;
                  this.dataSolicitud.telefonoAlterno = this.dataPaciente[0].datosPaciente.telefono;
                } else {
                  this.dataSolicitud.telefono = this.dataPaciente[0].datosPaciente.telefono;
                  this.dataSolicitud.telefonoAlterno = this.dataPaciente[0].datosPaciente.telefonoAlterno;
                }
                /* this.dataSolicitud.telefono=this.dataPaciente[0].telefono;
                this.dataSolicitud.telefonoAlterno=this.dataPaciente[0].telefonoAlterno; */
                this.statusTelefono = this.dataPaciente[0].datosPaciente.telefono == null ? false : true;
              } else {
                this.dataSolicitud.id_pacienteLocalizacion = "";
                this.dataSolicitud.paciente_id = "";
                this.dataSolicitud.nombre = "";
                this.dataSolicitud.ipress = "";
                this.dataSolicitud.distrito = "";
                this.dataSolicitud.telefono = "";
                this.dataSolicitud.telefonoAlterno = "";
                Swal.fire({
                  title: "¡Error!",
                  text: "¡Usted no se encuentra con cupo asignado, por favor completar su registro en admisión!",
                  icon: "error",
                  confirmButtonText: "Aceptar",
                });
              }
            })
            .catch((res) => {
              console.log("Error:", res);
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    updatePaciente() {
      for (const i in this.dataPaciente) {
        const element = this.dataPaciente[i];
        // Tu lógica aquí
        if (element.documento == this.dataSolicitud.num_docPaciente) {
          this.dataSolicitud.nombre = element.paciente;
          this.dataSolicitud.autogenerado = element.autogenerado;
          this.dataSolicitud.apellidosNombres = element.paciente;
          this.dataSolicitud.fecha_nacimiento = this.formatDates(
            element.fecha_nacimiento
          );
          this.documento.edad = this.calculateAge(element.fecha_nacimiento);
          this.documento.sexo = element.genero;
          this.documento.gradoInstruccion = element.grado_instruccion;
          this.documento.id_paciente = element.url;
          break;
        }
        if (element.documento != this.documento.numero) {
          this.documento.tipo = "";
          this.documento.autogenerado = "";
          this.documento.apellidosNombres = "";
          this.documento.fecha_nacimiento = "";
          this.documento.edad = "";
          this.documento.sexo = "";
          this.documento.gradoInstruccion = "";
        }
      }
    },
    clearForm() {
      this.dataSolicitud = {
        id_pacienteLocalizacion: null,
        num_docPaciente: null,
        nombre: null,
        ipress: null,
        distrito: null,
        telefono: null,
        telefonoAlterno: null,
        motivo: null,
        otro: null,
        distrito_nuevo: null,
        ipress_nuevo: null,
        distrito_nuevo2: null,
        ipress_nuevo2: null,
        num_doc: null,
        parentesco: null,
        telefono2: null,
        es_titular: false,
        fecha: new Date().toISOString().substr(0, 10),
        id_cas_1: null,
        id_cas_2: null,
        paciente_id: null,
        estado: false,
        url: false
      }
    },
  },

  mounted() {
  },
  created() {
    this.loadIpress();
    this.usuario = sessionStorage.getItem("usuario");
  },
};
</script>
